module.exports = __webpack_public_path__ + "img/duigou.3fdda897.svg";